import { createContext } from 'react';

import { SocialAccount } from 'api';

export interface SelectedNetworks {
  selectedNetworks: Array<SocialAccount | string>;
  toggleNetwork: (connection: SocialAccount | string) => void;
}

export const SelectedNetworksContext = createContext<SelectedNetworks>({
  selectedNetworks: [],
  toggleNetwork: () => undefined,
});

export const SelectedNetworksProvider = SelectedNetworksContext.Provider;
